import intl from "react-intl-universal"

import { useEffect, useState } from "react"
import styles from "./index.module.scss"
import Button from "../../atoms/Button"
import RcmpHeader from "../../atoms/Header"
import ContentBlank from "../../molecules/ContentBlank"
import FileIcon from "../../../assets/icons/FileIco"
import IconCiq from "../../../assets/icons/CIQIcon"
import BeakerIcon from "../../../assets/icons/Beaker"
import { useNavigate } from "react-router-dom"
import { checkingStep } from "../../../services/ciq"
import RcmpLoading from "../../atoms/Loading"
import { FirstRegisterOk } from "../../../assets/icons/FirstRegisterOk"
import EquipmentMinimal from "./pages/EquipmentMininal"
import { equipmentsMinimal } from "../../../services/ciq"
import IAtom from "../../../assets/icons/IAtom"
import IControl from "../../../assets/icons/Control"
import IEqp from "../../../assets/icons/Equipment"
import { fnCanAtLeast } from "../../../utils/permissions"
import PageTabs from "./components/PageTabs"

export default function CIQPage() {
  const [isLoading, setIslLoading] = useState(false)
  const [bcompletedStep, setBcompletedStep] = useState(false)
  const [dataStep, setDataStep] = useState({})
  const [dataEquipments, setDataEquipments] = useState([])
  const navigate = useNavigate()
  const navigateModelCiq = [
    {
      step: intl.get("ciq.step_one"),
      stepRegister: intl.get("ciq.step_one_register"),
      stepRegisterText: intl.get("ciq.step_one_register_text"),
      navigatePath: () => navigate("/ciq/list-analytes"),
      label: intl.get("ciq.list_analytes.exame_analyte"),
      status: dataStep?.step1?.status,
    },
    {
      step: intl.get("ciq.step_two"),
      stepRegister: intl.get("ciq.step_two_register"),
      stepRegisterText: intl.get("ciq.step_two_register_text"),
      navigatePath: () => navigate("/ciq/list-equipments"),
      label: intl.get("ciq.equipment"),
      status: dataStep?.step2?.status,
    },
    {
      step: intl.get("ciq.step_three"),
      stepRegister: intl.get("ciq.step_three_register"),
      stepRegisterText: intl.get("ciq.step_three_register_text"),
      navigatePath: () => navigate("/ciq/list-controls"),
      label: intl.get("ciq.controls"),
      status: dataStep?.step3?.status,
    },
  ]

  const verifyStep = async () => {
    try {
      setIslLoading(true)
      const response = await checkingStep()

      const data = response.data.data

      let incompleteStep = null

      for (const stepKey in data) {
        if (Object.prototype.hasOwnProperty.call(data, stepKey)) {
          const step = data[stepKey]

          if (!step.status) {
            incompleteStep = step.name
            break
          }
        }
      }

      if (incompleteStep === null) {
        setBcompletedStep(true)
      }

      setDataStep(data)
    } catch (err) {
      console.log(err)
    } finally {
      setIslLoading(false)
    }
  }

  const [labels, setLabels] = useState({
    release: intl.get("ciq.releases"),
    controls: intl.get("ciq.controls"),
    analytes: intl.get("ciq.list_analytes.exame_analyte"),
    equipment: intl.get("ciq.equipment"),
  })

  const [aBreadcrumb, setABreadcrumb] = useState([
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/ciq",
      name: intl.get("ciq.title"),
      bActive: true,
    },
  ])

  const listEquipments = async () => {
    try {
      const response = await equipmentsMinimal()
      setDataEquipments(response.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!fnCanAtLeast("access-ciq", "internal-quality-control")) {
      window.location.href = "/"
      return
    }

    setTimeout(() => {
      setLabels({
        controls: intl.get("ciq.controls"),
        analytes: intl.get("ciq.list_analytes.exame_analyte"),
        equipment: intl.get("ciq.equipment"),
      })

      setABreadcrumb([
        {
          path: "./",
          name: intl.get("home"),
        },
        {
          path: "/ciq",
          name: intl.get("ciq.title"),
          bActive: true,
        },
      ])
    }, 100)
    verifyStep()
    listEquipments()
  }, [])

  return isLoading ? (
    <div>
      <RcmpHeader
        cTitlePage={intl.get("ciq.internal_control_quality")}
        elIcon={<IconCiq />}
        aBreadCrumbs={aBreadcrumb}
      >
        <PageTabs currentTab={1} />
      </RcmpHeader>
      <ContentBlank
        bSwitchable={false}
        className={styles.contentBlankCustom}
        sButtonLabel={intl.get("ciq.list_analytes.order")}
        bVisibleIconSearch={false}

      >
        <div className={styles.loading}>
          <RcmpLoading bShow={true} size={60} />
        </div>
      </ContentBlank>
    </div>
  ) : bcompletedStep ? (
    <EquipmentMinimal dataEquipments={dataEquipments} listEquipment={dataEquipments} />
  ) : (
    <div>
      <RcmpHeader
        cTitlePage={intl.get("ciq.internal_control_quality")}
        elIcon={<IconCiq />}
        className={styles.header}
        aBreadCrumbs={aBreadcrumb}
      />
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bSwitchable={false}
        className={styles.contentBlankCustom}
        sButtonLabel={intl.get("ciq.list_analytes.order")}
        bVisibleIconSearch={false}
        cText={intl.get("ciq.text_config_ciq")}
        aEllipsisContent={[
          {
            label: labels.analytes,
            icon: <IAtom width="25" height="22" />,
            onClick: () => navigate("/ciq/list-analytes"),
          },
          {
            label: labels.equipment,
            icon: <IControl width="25" height="22" />,
            onClick: () => navigate("/ciq/list-equipments"),
          },
          {
            label: labels.controls,
            icon: <IEqp width="25" height="22" />,
            onClick: () => navigate("/ciq/list-controls"),
          },
        ]}
        bHasVideoTutorial={true}
      >
        <div className={styles.containerCIQ}>
          <div className={styles.containerLinks}>
            {navigateModelCiq.map((item) => (
              <div className={styles.cardLinks} key={item.step}>
                <h2>
                  {item.step}
                  <span>{item.stepRegister}</span>
                </h2>
                <p>{item.stepRegisterText}</p>
                {item?.status ? (
                  <FirstRegisterOk className={styles.iconOk} />
                ) : (
                  <div
                    style={{
                      height: "2.4rem",
                    }}
                  />
                )}
                <Button
                  className={styles.btnAncor}
                  onClick={() => {
                    item.navigatePath()
                  }}
                >
                  <BeakerIcon />
                  {item.label}
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className=""></div>
      </ContentBlank>
    </div>
  )
}
